import axios from 'axios';

/*
 * The server gives every answer an X-Request-Id (RequestLogFilter) and writes it on every log line of that request.
 * When a request fails, its id is remembered here for a few seconds, so the error message shown right after can
 * carry it ("Ref: 3fa9c01b2e") and, when copied for support, lets the log be searched for exactly that request.
 * No call site passes anything: a message is matched to the failure that came just before it.
 */

const FRESH_MS = 5000;
let lastFailure = null;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const id = error?.response?.headers?.['x-request-id'];
    if (id) lastFailure = { id, at: Date.now() };
    return Promise.reject(error);
  }
);

/** The id of the request that failed in the last few seconds, or null. */
export const recentRequestId = (now = Date.now()) =>
  lastFailure && now - lastFailure.at <= FRESH_MS ? lastFailure.id : null;

export const forgetRequestId = () => {
  lastFailure = null;
};
